import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { resetSoundAction } from './redux/actions';

const SoundPlayer: React.FC = () => {
  const successAudioRef = useRef<HTMLAudioElement | null>(null);
  const failureAudioRef = useRef<HTMLAudioElement | null>(null);
  const soundState = useSelector((state: any) => state.sound); 
  const { playSound, soundType } = soundState;
  const dispatch = useDispatch();

  useEffect(() => {
    if (playSound) {
      if (soundType === 'scan_success' && successAudioRef.current) {
        successAudioRef.current
          .play()
          .then(() => {
            dispatch(resetSoundAction());
          })
          .catch((error) => {
            console.error('Error playing success sound:', error);
          });
      } else if (soundType === 'scan_failure' && failureAudioRef.current) {
        failureAudioRef.current
          .play()
          .then(() => {
            dispatch(resetSoundAction());
          })
          .catch((error) => {
            console.error('Error playing failure sound:', error);
          });
      }

    }
  },[playSound, soundType, dispatch] );

  return (
    <>
      <audio ref={successAudioRef} src="/sounds/success.mp3" preload="none" />
      <audio ref={failureAudioRef} src="/sounds/failure.mp3" preload="none" />
    </>
  );
};

export default SoundPlayer;